module.exports = __webpack_public_path__ + "static/media/twitchtweets.254d4db6.png";